import React, { PropsWithChildren } from 'react'

type Props = {
  fallback?: React.ReactNode
  condition: boolean
}

function Switch(props: PropsWithChildren<Props>) {
  const { condition, children, fallback = null } = props
  if (condition) {
    return <>{children}</>
  }

  if (!fallback) {
    return null
  }

  return <>{fallback}</>
}

export default Switch
